import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { TaskSummary } from '@/components/features/tasks/payment/TaskSummary';
import { TaskProgress } from '@/components/features/tasks/payment/TaskProgress';
import { TaskFiles } from '@/components/features/tasks/payment/TaskFiles';
import { Comments } from '@/components/features/tasks/payment/Comments';
import { ToDoList } from '@/components/features/tasks/payment/ToDoList';
import { Activities } from '@/components/features/tasks/payment/Activities';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { ProjectInfo } from '@/components/features/tasks/payment/ProjectInfo';
import { ContractAlert } from '@/components/features/tasks/payment/ContractAlert';
import { GenerateAfterCompletedAlert } from '@/components/features/tasks/payment/GenerateAfterCompletedAlert';

export const PaymentTask = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_, _t_, me, meTeamMember, isTeamAdmin, isApprover, isFinancialOfficer, isBackoffice, isMember } =
    useCurrentTeamMember();
  const { _po_ } = useCurrentPurchaseOrder();
  useEffect(() => setTitle(`支払タスク詳細`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `プロジェクト（費用） - ${_t_!.name}`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders`,
        },
        {
          label: `プロジェクト（費用）詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}`,
        },
      ]),
    []
  );

  const { paymentTask: task } = useCurrentPaymentTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <ContractAlert />
        <GenerateAfterCompletedAlert />

        <div className="row">
          <div className="col-12 col-lg-7">
            <ToDoList />

            <TaskFiles />

            <Comments />
          </div>

          <div className="col-12 col-lg-5">
            <TaskSummary />

            <TaskProgress />

            <ProjectInfo />

            <Activities />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
